import React, { FC, useState } from 'react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';

import { Auth } from '../../helpers/Auth';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const SignIn: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const signIn = () => {
    Auth.signIn(email, password)
      .then(() => {
        navigate(location.state?.from?.pathname || '/');
      })
      .catch((reason) => {
        const message =
          reason.response.data.message && reason.response.data.message[0].messages
            ? reason.response.data.message[0].messages[0].message
            : 'Impossibile eseguire il login';

        enqueueSnackbar(message, { variant: 'error' });
      });
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Typography component="h1" variant="h5">
          Accedi
        </Typography>
        <form className={classes.form} noValidate>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label="Email"
            name="email"
            autoComplete="email"
            autoFocus
            onChange={(event) => setEmail(event.target.value)}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            autoComplete="current-password"
            onChange={(event) => setPassword(event.target.value)}
          />
          {/*<FormControlLabel control={<Checkbox value="remember" color="primary" />} label="Remember me" />*/}
          <Button fullWidth variant="contained" color="primary" className={classes.submit} onClick={() => signIn()}>
            Login
          </Button>
          <Grid container>
            <Grid item xs>
              <Link to="/forgot-password" variant="body2" component={RouterLink}>
                Password dimenticata?
              </Link>
            </Grid>
            <Grid item>
              <Link to="/signup" variant="body2" component={RouterLink}>
                Non hai un account? Registrati!
              </Link>
            </Grid>
          </Grid>
        </form>
      </div>
    </Container>
  );
};

export default SignIn;
